import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    step: 1,
    personalData: {
      position: '',
      expected_salary: '',
      field_study: '',
      name_title: '',
      name_title_other: '',
      firstname: '',
      lastname: '',
      firstname_en: '',
      lastname_en: '',
      age: '',
      weight: '',
      height: '',
      race: '',
      nationality: '',
      religion: '',
      email: '',
      phone_number: '',
      id_card_number: '',
      marital_status: '',
      profile_url: '',
      military_status: '',
      house_no: '',
      building: '',
      village_no: '',
      lane: '',
      road: '',
      sub_district: '',
      district: '',
      province: '',
      postal_code: '',
    },

    education: [
      {
        title: 'ระดับ ประถมศึกษา (Primary School)',
        level: '',
        since: '',
        to: '',
        institut: '',
        field_of_study: '',
        grade: '',
        default: true,
      },
      {
        title: 'ระดับ มัธยมศึกษา (Secondary school)',
        level: '',
        since: '',
        to: '',
        institut: '',
        field_of_study: '',
        grade: '',
        default: true,
      },
      {
        title: 'ระดับ วิิทยาลัย / มหาวิทยาลัย (College/University)',
        level: '',
        since: '',
        to: '',
        institut: '',
        field_of_study: '',
        grade: '',
        default: true,
      },
    ],

    employmentRecord: [
      {
        since: '',
        to: '',
        position: '',
        company_name: '',
        business_type: '',
        job: '',
        resignation: '',
        default: true,
      },
    ],

    skills: {
      language: [
        {
          title: 'อังกฤษ',
          listening: '',
          speaking: '',
          reading: '',
          writing: '',
          default: true,
        },
        {
          title: 'ญี่ปุ่น',
          listening: '',
          speaking: '',
          reading: '',
          writing: '',
          default: true,
        },
      ],
      driver_license: [],
      computer: '',
      hobbies: '',
      additional: '',
    },
  },
  mutations: {
    SET_STEP(state, data) {
      state.step = data
    },

    SET_PERSONAL_DATA(state, data) {
      state.personalData = data
    },

    SET_EDUCATION(state, data) {
      state.education = data
    },

    SET_SKILLS(state, data) {
      state.skills = data
    },

    SET_EMPLOYMENT_RECORD(state, data) {
      state.employmentRecord = data
    },
  },
  plugins: [new VuexPersistence().plugin],
})

export default store
